import { useEffect, useMemo, useRef } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { defaultMST4030_R01Filter, useMST4030_R01Store } from "./Store_MST4030_R01";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import useUiuxStore from "src/store/useUiuxStore";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { blueButtonClass } from "src/components/common/common";

interface Props {
	onBulkLabelClick: () => void;
}

export const SearchSection_MST4030_R01 = ({ onBulkLabelClick }: Props) => {

	const { eqmStatusList } = useCommonCodeStore();
	//const eqmStatusOptions = useMemo(() => {
	//	if (!eqmStatusList || eqmStatusList.length === 0) return [];
	//	const copied = [...eqmStatusList];
	//	const goodIndex = copied.findIndex((item) => item.minorCd === 'GOOD');
	//	if (goodIndex <= 0) return copied;
	//	const [goodOption] = copied.splice(goodIndex, 1);
	//	return [goodOption, ...copied];
	//}, [eqmStatusList]);

	const { MST4030_R01Filter, setMST4030_R01Filter, MST4030_R01List } = useMST4030_R01Store();
	const hasInitEqmStatus = useRef(false);
	const { setCodeSearchModalProps } = useUiuxStore();

//// 설비상태가 GOOD인 옵션이 있으면 기본값으로 설정 (초기 로드시 한 번만 실행)
//	useEffect(() => {
//		if (!eqmStatusList || eqmStatusList.length === 0) return;
//		if (hasInitEqmStatus.current) return;
//		if (MST4030_R01Filter.eqmStatus) {
//			hasInitEqmStatus.current = true;
//			return;
//		}
//		const hasGood = eqmStatusList.some((item) => item.minorCd === 'GOOD');
//		if (hasGood) {
//			setMST4030_R01Filter({ eqmStatus: 'GOOD' });
//			hasInitEqmStatus.current = true;
//		}
//	}, [eqmStatusList, MST4030_R01Filter.eqmStatus, setMST4030_R01Filter]);

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'equipmentCd',
			category: '메탈마스크',
			focusId: 'equipmentCd_search',
			responseMapping: {
				equipmentCd: 'equipmentCd',
				equipmentNm: 'equipmentNm',
			},
			extraFilter: () => ({
				equipmentCd: MST4030_R01Filter.equipmentCd || '',
				equipmentNm: MST4030_R01Filter.equipmentNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: MST4030_R01Filter,
		setEditData: setMST4030_R01Filter,
		defaultData: defaultMST4030_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'MST4030_R01_search'
	});

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="설비상태"
				value={MST4030_R01Filter.eqmStatus || ''}
				onChangeItem={(item) => setMST4030_R01Filter({ eqmStatus: item?.minorCd || '' })}
				optionList={eqmStatusList}
			/>
			<SearchCodeModalForm
				label="설비코드"
				value={MST4030_R01Filter.equipmentCd}
				valueLabel={
					MST4030_R01Filter.equipmentNm.length > 23
						? MST4030_R01Filter.equipmentNm.slice(0, 23) + '...'
						: MST4030_R01Filter.equipmentNm
				}
				handleFoucsId="equipmentCd_search"
				onChange={getFieldHandlers('equipmentCd').onChange}
				onDoubleClick={getFieldHandlers('equipmentCd').onDoubleClick}
				onKeyDown={getFieldHandlers('equipmentCd').onEnterKeyDown}
			/>
			<div className="flex-shrink-0 ml-[90px] self-center">
			<button
				type="button"
				onClick={onBulkLabelClick}
				disabled={MST4030_R01List.length === 0}
				className={`h-full px-4 text-[12px] font-semibold text-white rounded-[4px] inline-flex items-center gap-1
					${MST4030_R01List.length === 0 ? 'bg-gray-300 cursor-not-allowed' : blueButtonClass}`}
			>
				<svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-4" fill="none"
					viewBox="0 0 24 24" stroke="currentColor">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
						d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
				</svg>
				대량 출력
			</button>
			</div>
		</SearchSectionForm>
	);
};
